import React, { useEffect, useState } from "react";
import {
  IonPage,
  IonContent,
  IonHeader,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonSelect,
  IonSelectOption,
  IonToast,
} from "@ionic/react";
import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TextField,
  Typography,
  Paper,
  Checkbox,
  FormControlLabel,
  Skeleton,
} from "@mui/material";
import { Edit, Delete, Email, Phone } from "@mui/icons-material";
import { useBusinessContext } from "../../context/business-context";
import { useHistory } from "react-router-dom";


const ManageCustomers: React.FC = () => {
  const [messageType, setMessageType] = useState<string>("email");
  const [selectedMessageTypes, setSelectedMessageTypes] = useState<string[]>(
    []
  );
  // const [recipient, setRecipient] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [customers, setCustomers] = useState<any[]>([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [popupMessage, setPopupMessage] = useState<string>("");
  const { selectedBusinessId } = useBusinessContext();
  const history = useHistory();

  // useEffect(() => {
  //   fetchBranches();
  //   fetchCustomers();
  // }, []);

  useEffect(() => {
    if (selectedBusinessId) {
      fetchBranches();
      fetchCustomers();
    }
  }, [selectedBusinessId]); // Re-run when `selectedBusinessId` changes

  const fetchBranches = async () => {
    try {
      const response = await axios.post(
        baseUrl() + "Businesss/getBranchList",
        { requestID: requestID(), business_id: selectedBusinessId },
        config
      );
      setBranches(response.data.data || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
    setLoading(false);
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.post(
        baseUrl() + "users/getCustomers",
        { requestID: requestID(), business_id: selectedBusinessId },
        config
      );
      // setCustomers(response.data.data[0] || []);
      setCustomers(
        Array.isArray(response.data.data) ? response.data.data.flat() : []
      );
      console.log("Customers:", response);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
    setLoading(false);
  };

  const deleteCustomer = async (customerId: string) => {
    try {
      await axios.post(
        baseUrl() + "business/deleteCustomer",
        { requestID: requestID(), customer_id: customerId },
        config
      );
      setCustomers(
        customers.filter((customer) => customer.customer_id !== customerId)
      );
    } catch (error) {
      console.error("Error deleting customer:", error);
    }
  };

  // const sendMessageToAll = () => {
  //   if (messageType === "email") {
  //     const emails = customers.map((customer) => customer.email).join(",");
  //     window.location.href = `mailto:${emails}?body=${encodeURIComponent(
  //       message
  //     )}`;
  //   } else {
  //     const phones = customers.map((customer) => customer.phone).join(",");
  //     window.location.href = `sms:${phones}?body=${encodeURIComponent(
  //       message
  //     )}`;
  //   }
  // };

  // const sendMessageToCustomers = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("requestID", requestID());
  //     formData.append("message", message);
  //     formData.append("email", selectedMessageTypes[0] ? "true" : "false");
  //     formData.append("sms", selectedMessageTypes[1] ? "true" : "false");
  //     formData.append("notification", selectedMessageTypes[2] ? "true" : "false");
  //     formData.append("recipient", recipient);
  //     if (subject) {
  //       formData.append("subject", subject);
  //     }
  
  //     const response = await axios.post(
  //       baseUrl() + "messages/send",
  //       formData,
  //       config
  //     );
  
  //     if (response.data.success) {
  //       alert("Message sent successfully!");
  //     } else {
  //       alert("Failed to send message. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error sending message:", error);
  //     alert("An error occurred while sending the message.");
  //   }
  // };
  
  const sendMessageToCustomers = async () => {
    setLoading(true);
    try {
      const recipients = filteredCustomers.map((customer) => customer.email || customer.phone);
      
      if (recipients.length === 0) {
        setPopupMessage("No recipients available");
        setLoading(false);
        return;
      }

      if (!message.trim()) {
        setPopupMessage("Please enter a message to send");
        setLoading(false);
        return;
      }

      if (selectedMessageTypes.length === 0) {
        setPopupMessage("Please select at least one message type (Email, SMS, or Notification)");
        setLoading(false);
        return;
      }
  
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("message", message);
      formData.append("email", selectedMessageTypes.includes("email") ? "true" : "false");
      formData.append("sms", selectedMessageTypes.includes("sms") ? "true" : "false");
      formData.append("notification", selectedMessageTypes.includes("pushnotification") ? "true" : "false");
      formData.append("recipients", JSON.stringify(recipients)); // Send as JSON array
      if (subject) {
        formData.append("subject", subject);
      }
  
      const response = await axios.post(
        baseUrl() + "messages/send",  
        formData,
        config
      );

      console.log("Response:", response);
  
      if (response.data.success) {
        
        
        setPopupMessage("Message sent successfully!");
      } else {
        setPopupMessage("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setPopupMessage("An error occurred while sending the message.");
    }
    setLoading(false);
  };
  
  

  const handleSendMessage = () => {
    if (selectedMessageTypes.length === 0) {
      alert("Please select at least one message type (Email, Phone, or SMS)");
      return;
    }

    if (selectedMessageTypes.includes("email")) {
      const emails = customers.map((customer) => customer.email).join(",");
      window.location.href = `mailto:${emails}?body=${encodeURIComponent(
        message
      )}`;
    }

    if (selectedMessageTypes.includes("sms")) {
      const phones = customers.map((customer) => customer.phone).join(",");
      window.location.href = `sms:${phones}?body=${encodeURIComponent(
        message
      )}`;
    }

    if (selectedMessageTypes.includes("pushnotification")) {
      const phones = customers.map((customer) => customer.phone).join(",");
      window.location.href = `tel:${phones}`;
    }
  };

  const handleCheckboxChange = (type: string) => {
    setSelectedMessageTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const handleSendEmail = (email: string) => {
    window.location.href = `mailto:${email}`;
  };

  const handleSendSMS = (phone: string) => {
    window.location.href = `sms:${phone}`;
  };

  const filteredCustomers = selectedBranch
    ? customers.filter((customer) => customer.branch_id === selectedBranch)
    : customers;

  return (
    <IonPage>
      <IonHeader style={{ backgroundColor: "white" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
            Manage Customers
          </Typography>
          <Button variant="contained" color="primary" onClick={() => history.push("/add-customer")}>
            Add Customer
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
            style={{ marginLeft: 10 }}
          >
            Go Back
          </Button>
        </Box>
      </IonHeader>
      <IonContent className="ion-padding">
        
          {/* <Select
            value={messageType}
            onChange={(e) => setMessageType(e.target.value)}
            displayEmpty
          >
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="phone">Phone</MenuItem>
            <MenuItem value="sms">SMS</MenuItem>
          </Select> */}
          {/* <Box mb={2} display="flex" gap={2} flexDirection="column"> */}
          
        <Box mb={2} display="flex" gap={1}>
          <TextField
            fullWidth
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          
          {/* <Button
            variant="contained"
            color="secondary"
            onClick={sendMessageToAll}
          >
            Send
          </Button> */}
          <Select
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.target.value)}
            fullWidth
            displayEmpty
            sx={{ color: "black" }}
          >
            {/* <MenuItem value="all" sx={{color:"black"}}>All Branches</MenuItem> */}
            <MenuItem value={""} sx={{ color: "black" }} disabled>
              Select Branch
            </MenuItem>
            <MenuItem value={""} sx={{ color: "black" }}>
              All Branches
            </MenuItem>
            {branches.map((branch) => (
              <MenuItem key={branch.branch_id} value={branch.branch_id}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
          
        </Box>
        <Box mb={2}>
        <TextField
            fullWidth
            multiline
            rows={4}
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          
        </Box>
        <Box display="flex" gap={0}  justifyContent={"space-between"} mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedMessageTypes.includes("email")}
                  onChange={() => handleCheckboxChange("email")}
                />
              }
              label="Email"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedMessageTypes.includes("sms")}
                  onChange={() => handleCheckboxChange("sms")}
                />
              }
              label="SMS"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedMessageTypes.includes("pushnotification")}
                  onChange={() => handleCheckboxChange("pushnotification")}
                />
              }
              label="Push Notification"
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={sendMessageToCustomers}
            disabled={loading}
            sx={{ flex: 0.5 }}
            
          >
            {loading ? "Sending..." : "Send"}
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                backgroundColor: "lightgrey",
                color: "black",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              <TableRow>
                {/* <TableCell>First Name</TableCell> */}
                <TableCell>Fullname</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone Number</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {customers
                .filter(customer => selectedBranch === "all" || customer.branch_id === selectedBranch) */}
              {loading ? (
                [...Array(5)].map((_, index) => (
                  <TableRow key={index}>
                    <TableCell><Skeleton variant="text" width={120} /></TableCell>
                    <TableCell><Skeleton variant="text" width={180} /></TableCell>
                    <TableCell><Skeleton variant="text" width={140} /></TableCell>
                    <TableCell><Skeleton variant="rectangular" width={100} height={30} /></TableCell>
                  </TableRow>
                ))
              ) : (
              filteredCustomers.map((customer) => (
                <TableRow key={customer.customer_id}>
                  {/* <TableCell>{customer.firstName}</TableCell> */}
                  <TableCell>{customer.uname}</TableCell>
                  <TableCell>{customer.email}</TableCell>
                  <TableCell>{customer.phone}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() =>
                        (window.location.href = `mailto:${customer.email}`)
                      }
                    >
                      {" "}
                      <Email />{" "}
                    </IconButton>
                    <IconButton
                      color="secondary"
                      onClick={() =>
                        (window.location.href = `sms:${customer.phone}`)
                      }
                    >
                      {" "}
                      <Phone />{" "}
                    </IconButton>
                    <IconButton
                      color="primary"
                      onClick={() =>
                        history.push("/edit-customer", { customer })
                      }
                    >
                      {" "}
                      <Edit />{" "}
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => deleteCustomer(customer.customer_id)}
                    >
                      {" "}
                      <Delete />{" "}
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <IonToast
          isOpen={popupMessage !== ""}
          onDidDismiss={() => setPopupMessage("")}
          message={popupMessage}
          duration={3000}
          color={popupMessage.includes("successfully") ? "success" : "danger"}
        />
      </IonContent>
    </IonPage>
  );
};

export default ManageCustomers;

